var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 8,
    viewBox: "0 0 23 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.43179 0.488283C3.3402 0.504189 3.25193 0.548751 3.17593 0.625001L0.142727 3.6582C-0.0462734 3.8472 -0.0462734 4.1528 0.142727 4.3418L3.17593 7.375C3.47993 7.68 4.00015 7.4632 4.00015 7.0332V5H21.0001C21.1327 5.00188 21.2642 4.97739 21.3872 4.92798C21.5102 4.87857 21.6221 4.80521 21.7165 4.71216C21.8108 4.61912 21.8858 4.50824 21.9369 4.38599C21.9881 4.26373 22.0144 4.13253 22.0144 4C22.0144 3.86748 21.9881 3.73627 21.9369 3.61402C21.8858 3.49176 21.8108 3.38089 21.7165 3.28784C21.6221 3.1948 21.5102 3.12144 21.3872 3.07202C21.2642 3.02261 21.1327 2.99813 21.0001 3H4.00015V0.966798C4.00015 0.643548 3.70657 0.440564 3.43179 0.488283Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow_left.f86b11140e4b464468e47c8c3af7cf27.svg";
export { ForwardRef as ReactComponent };